import "./Navbar.css";
import logo from "../../assets/logo.png";
import { useEffect, useMemo, useState } from "react";

const NAV_ITEMS = [
  { label: 'Home',              key: 'home' },
  { label: 'Our Services',      key: 'services' },
  { label: 'Our Doctors',       key: 'packages' },
  { label: 'Careers',           key: 'branches' },
  { label: 'About',             key: 'about' },
];

const SERVICES_SUB_ITEMS = [
  { label: 'In-Patient Services', key: 'services-inpatient' },
  { label: 'Out-Patient Services', key: 'services-outpatient' },
];

const ABOUT_SUB_ITEMS = [
  { label: "Vision & Mission", key: "about-vision-mission" },
  { label: "News & Events", key: "about-news-events" },
  { label: "Hospital Tour", key: "about-gallery" },
  { label: "FAQs & Complaints", key: "about-faqs-complaints" },
  { label: "Contact Us", key: "contact" },
];

function Logo({ onClick }) {
  return (
    <button className="navbar__logo" type="button" onClick={onClick}>
      <img className="navbar__logo-img" src={logo} alt="Capital Care International Hospital" />
      <div className="navbar__logo-text">
        <span className="navbar__logo-en">Capital Care International Hospital</span>
      </div>
    </button>
  );
}

export default function Navbar({ page, route, setPage }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openMobileGroup, setOpenMobileGroup] = useState(null);
  const activeRouteKey = route?.key || page;
  const activeServiceKey = useMemo(() => {
    if (activeRouteKey === "services-inpatient" || activeRouteKey === "services-outpatient") return activeRouteKey;
    return null;
  }, [activeRouteKey]);

  useEffect(() => {
    setMenuOpen(false);
    setOpenMobileGroup(null);
  }, [activeRouteKey]);

  const navigate = (key, options) => {
    setPage(key, options);
    setMenuOpen(false);
    setOpenMobileGroup(null);
  };

  return (
    <nav className={`navbar ${menuOpen ? "navbar--open" : ""}`}>
      <Logo onClick={() => navigate("home")} />

      <button
        className="navbar__toggle"
        type="button"
        aria-expanded={menuOpen}
        aria-controls="primary-navigation"
        onClick={() => setMenuOpen((value) => !value)}
      >
        <span className="navbar__toggle-line" />
        <span className="navbar__toggle-line" />
        <span className="navbar__toggle-line" />
      </button>

      <div className="navbar__overlay" onClick={() => setMenuOpen(false)} aria-hidden="true" />

      <ul className="navbar__links" id="primary-navigation">
        {NAV_ITEMS.map(item => {
          if (item.key === 'services') {
            return (
              <li key={item.key} className="navbar__item navbar__item--dropdown">
                <button
                  className={`navbar__link navbar__link--dropdown ${page === item.key ? 'navbar__link--active' : ''}`}
                  type="button"
                  onClick={() => {
                    if (window.innerWidth < 901) {
                      setOpenMobileGroup((value) => (value === item.key ? null : item.key));
                      return;
                    }
                    navigate('services');
                  }}
                  aria-expanded={openMobileGroup === item.key}
                >
                  {item.label}
                </button>

                <div className="navbar__dropdown" role="menu" aria-label="Our Services">
                  {SERVICES_SUB_ITEMS.map((sub) => {
                    return (
                      <button
                        key={sub.key}
                        className={`navbar__dropdown-link ${activeServiceKey === sub.key ? "navbar__dropdown-link--active" : ""}`}
                        type="button"
                        onClick={() => navigate(sub.key)}
                        role="menuitem"
                      >
                        {sub.label}
                      </button>
                    );
                  })}
                </div>
              </li>
            );
          }

          if (item.key === 'about') {
            return (
              <li key={item.key} className="navbar__item navbar__item--dropdown">
                <button
                  className={`navbar__link navbar__link--dropdown ${page === item.key ? 'navbar__link--active' : ''}`}
                  type="button"
                  onClick={() => {
                    if (window.innerWidth < 901) {
                      setOpenMobileGroup((value) => (value === item.key ? null : item.key));
                      return;
                    }
                    navigate('about-us');
                  }}
                  aria-expanded={openMobileGroup === item.key}
                >
                  {item.label}
                </button>

                <div className="navbar__dropdown" role="menu" aria-label="About">
                  {ABOUT_SUB_ITEMS.map((sub) => {
                    const isActive = activeRouteKey === sub.key;
                    return (
                      <button
                        key={sub.key}
                        className={`navbar__dropdown-link ${isActive ? "navbar__dropdown-link--active" : ""}`}
                        type="button"
                        onClick={() => navigate(sub.key)}
                        role="menuitem"
                      >
                        {sub.label}
                      </button>
                    );
                  })}
                </div>
              </li>
            );
          }

          return (
              <li key={item.key}>
                <button
                  className={`navbar__link ${page === item.key ? 'navbar__link--active' : ''}`}
                  type="button"
                  onClick={() => setPage(item.key)}
                >
                  {item.label}
                </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
